export { default as PasswordRecovery } from './password-recovery';
